import * as React from 'react';

const HeadTags = ({ description , ogUrl , ogImage , headComponent: Component = React.Fragment , title , hreflangs , ogSiteName , noFollow , noIndex , children ,  })=>/*#__PURE__*/ React.createElement(Component, null, /*#__PURE__*/ React.createElement("title", null, title), ogUrl && /*#__PURE__*/ React.createElement("link", {
        rel: "canonical",
        href: ogUrl
    }), hreflangs.map(({ url , locale  })=>/*#__PURE__*/ React.createElement("link", {
            rel: "alternate",
            key: url,
            hrefLang: locale,
            href: url
        })
    ), /*#__PURE__*/ React.createElement("meta", {
        name: "robots",
        content: `${noIndex ? 'noindex' : 'index'}, ${noFollow ? 'nofollow' : 'follow'}, max-image-preview:large`
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:url",
        content: ogUrl
    }), ogSiteName && /*#__PURE__*/ React.createElement("meta", {
        property: "og:site_name",
        content: ogSiteName
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:title",
        content: title
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "description",
        content: description
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:description",
        content: description
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:site",
        content: ogUrl
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:card",
        content: "summary_large_image"
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:image",
        content: ogImage
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:image",
        content: ogImage
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:image:width",
        content: "1200"
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:image:height",
        content: "630"
    }), children)
;
var HeadTags$1 = HeadTags;

export { HeadTags, HeadTags$1 as default };
//# sourceMappingURL=HeadTags.js.map
